export default __webpack_public_path__ + "static/media/doctor-page-icon.05723405.svg";